import { showErrorMessage } from 'actions/messages';
import { projectsApi } from 'services/api/projects-api';
import {
  PROJECT_DETAILS_INIT,
  PROJECT_DETAILS_CURRENT_PROJECT_SET,
  PROJECT_DETAILS_NAV_BAR_SELECTION,
  SHOW_PDF_VIEWER_SET,
} from 'components/admin/projects/details/store/action-types';
import { projectResourceMailerApi } from 'services/api/project-resource-mailer-api';
import { setShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/actions';

export function initProjectDetails() {
  return {
    type: PROJECT_DETAILS_INIT,
  };
}

export function loadProjectSuccess(project) {
  return {
    type: PROJECT_DETAILS_CURRENT_PROJECT_SET,
    payload: project,
  };
}

export function loadProjectRequest(prjectId) {
  return (dispatch) => {
    return projectsApi.getProject(prjectId).then((response) => {
      if (response.ok) {
        dispatch(loadProjectSuccess(response.project));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
      return response;
    });
  };
}

export function selectNavigationBar(value) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_DETAILS_NAV_BAR_SELECTION,
      payload: value,
    });
  };
}

export function sendProjectResourceEmails(resourceId, resourceType, emailData) {
  return (dispatch) => {
    return projectResourceMailerApi
      .postResourceEmails(resourceId, resourceType, emailData)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowEmailModal(false));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setShowPdfViewer(showPdfViewer) {
  return {
    type: SHOW_PDF_VIEWER_SET,
    payload: showPdfViewer,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/store/actions.js